import React, { useContext } from 'react';
import Avatar from '../Avatar';
import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';
import { AdminContext } from '../../context/AdminContext';

export default function SingleContact({ contact, showOnline = true }) {
  const { direction } = useContext(AdminContext);
  return (
    <div className={`flex flex-row justify-start items-center `}>
      <Avatar
        width={34}
        height={34}
        containerclassName={`cursorDefault relative`}
        className={`cursorDefault`}
        src={
          contact?.channelUser?.image?.name
            ? contact?.channelUser?.image?.name
            : blanckUser
        }
        local={!contact?.channelUser?.image?.name}
      >
        {showOnline && contact?.channelUser?.statusId == 1 && (
          <div
            className={`${'onlineUser'} ${
              direction == 'rtl' ? 'onlineUserRtl' : 'onlineUserLtr'
            }`}
          ></div>
        )}
      </Avatar>
      <p className={`text-right mr-[5px]`}>
        {contact?.channelUser?.channelName
          ? contact?.channelUser?.channelName
          : contact?.channelUser?.username}
      </p>
    </div>
  );
}
